import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import { HappyScroll } from 'vue-happy-scroll'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/variables.scss';
import axios from 'axios';
Vue.prototype.$axios = axios;
import router from './router'
import store from './store'
 
Vue.use(ElementUI);
Vue.component('happy-scroll', HappyScroll)
import 'vue-happy-scroll/docs/happy-scroll.css'

Vue.config.productionTip = false
// console.log = () => {};
new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
